// extracted by mini-css-extract-plugin
export var heading = "Accordion-module--heading--f43b2";
export var item = "Accordion-module--item--38b9c";
export var items = "Accordion-module--items--80d2e";
export var section = "Accordion-module--section--26faa";